import audio_error from "../../assets/sound/sound-error-box.mp3"

const sound = new Audio(audio_error)

export const ErrorAudioBoxs = (err = '', isShowModal = false, errData = [], isOpenErrData= false) => {
    if(isShowModal && err !== "") sound.play()

    if(errData.length > 0 && isOpenErrData) sound.play()

    if(!isShowModal && !isOpenErrData) sound.load()
}